<template>
  <section
    v-if="block?.Metrics?.length"
    class="metrics-section content-section surface-panel"
    :class="{
      'metrics-section--relaxed': relaxedVerticalSpacing,
    }">
    <div class="container">
      <h2 class="metrics__title">{{ block.Title }}</h2>
      <div
        class="metrics__grid"
        :class="{ 'metrics__grid--max-3': maxColumns === 3 }">
        <UiPrePeersMetricCard
          v-for="(metric, index) in block.Metrics"
          :key="index"
          :metric="metric"
          :compact-value-desktop="compactValueDesktop" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { MetricsBlock } from '~/types/school'

defineProps({
  block: {
    type: Object as PropType<MetricsBlock | null | undefined>,
    default: undefined,
  },
  maxColumns: {
    type: Number,
    default: 4,
    validator: (n: number) => n === 3 || n === 4,
  },
  relaxedVerticalSpacing: {
    type: Boolean,
    default: false,
  },
  compactValueDesktop: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.metrics-section {
  margin-block: 0;
}

.metrics-section--relaxed {
  margin-block: var(--space-12);
}

.metrics__title {
  font-size: var(--text-2xl);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: var(--space-8);
  text-align: left;
}

.metrics__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--space-5);
  max-width: 100%;
  margin-inline: auto;
}

.metrics__grid--max-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.metrics-section--relaxed .metrics__title {
  margin-bottom: var(--space-10);
}

.metrics-section--relaxed .metrics__grid {
  gap: var(--space-6);
}

@media (max-width: 1024px) {
  .metrics__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-5);
  }

  .metrics__grid--max-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .metrics-section--relaxed {
    margin-block: var(--space-10);
  }

  .metrics-section--relaxed .metrics__grid {
    gap: var(--space-5);
  }

  .metrics__title {
    font-size: var(--text-xl);
    margin-bottom: var(--space-6);
  }

  .metrics__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--space-4);
  }

  .metrics__grid--max-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .metrics-section--relaxed {
    margin-block: var(--space-8);
  }

  .metrics__title {
    font-size: var(--text-lg);
    margin-bottom: var(--space-6);
  }

  .metrics__grid,
  .metrics__grid--max-3 {
    grid-template-columns: 1fr;
    gap: var(--space-3);
  }

  .metrics-section--relaxed .metrics__grid {
    gap: var(--space-5);
  }
}
</style>
